<div class="title-tab-step text-center">
  {{ 'INFECTIONCONTROLCATEGORIES' | translate }}
</div>
<div class="row">

  <!-- category area -->
  <div class="col-4 card">
    <div class="title-tab-step text-center">
      {{ 'Categories' | translate }}
    </div>
    <div class="row">

      <div class="col-md-12">
        <div class="card-body">
          <div class=" col p-1 ui-datatable-tablewrapper">
            <table class="table table-bordered table-striped">
              <thead class="ui-datatable-thead">
                <tr>
                  <th style="width:20%;">{{ 'CODE' | translate }}</th>
                  <th style="width:20%;">{{ 'DESCNAMEAR' | translate }}</th>
                  <th style="width:20%;">{{ 'DESCNAMEEN' | translate }}</th>
                  <th style="width:20%;">{{ 'ACTIVE' | translate }}</th>
                  <th style="width:10%;">
                    <i (click)="addCategoryRow()" class="fa fa-plus fa-2x"></i>
                  </th>
                </tr>
              </thead>
              <tbody class="ui-datatable-data ui-widget-content">
                <tr class="ui-widget-content" *ngFor="let item of categoriesList; index as indx">
                  <td>
                    <input [(ngModel)]="item.serial" disabled placeholder="code" type="text" class="form-control">
                  </td>
                  <td>
                    <input [(ngModel)]="item.descAr" [disabled]="item.dataStatus==0 || !item.dataStatus"
                      placeholder="Arabic Name" type="text" class="form-control">
                  </td>
                  <td>
                    <input [(ngModel)]="item.descEn" [disabled]="item.dataStatus==0 || !item.dataStatus "
                      placeholder="English Name" type="text" class="form-control">
                  </td>
                  <td>
                    <input [(ngModel)]="item.isActive" [disabled]="item.dataStatus==0 || !item.dataStatus"
                      placeholder="active" type="checkbox" class="form-control" (change)="isActiveChange($event,item)">
                  </td>

                  <td>
                    <icon-action (clicked)="onCategoryIconClicked($event , item)"
                      [appCodes]="[404,307,3]"></icon-action>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row" *ngIf="categoriesList.length>0">
            <div class="col">
              <btns-ctrl #btnCtrl1 [appCodes]="[1]" (clicked)="onCategorySaveClicked($event,1)"></btns-ctrl>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- sub category area -->
  <div class="col-4 card">
    <div class="title-tab-step text-center">
      {{ 'SUBCATEGORIES' | translate }}
    </div>
    <div class="row">

      <div class="col-md-12">
        <div class="card-body">
          <div class=" col p-1 ui-datatable-tablewrapper">
            <table class="table table-bordered table-striped">
              <thead class="ui-datatable-thead">
                <tr>
                  <th style="width:20%;">{{ 'CODE' | translate }}</th>
                  <th style="width:20%;">{{ 'DESCNAMEAR' | translate }}</th>
                  <th style="width:20%;">{{ 'DESCNAMEEN' | translate }}</th>
                  <th style="width:20%;">{{ 'ACTIVE' | translate }}</th>


                  <th style="width:10%;" *ngIf="categoriesObj.serial>0">
                    <i (click)="addSubCategoryRow(1)" class="fa fa-plus fa-2x"></i>
                  </th>
                </tr>
              </thead>
              <tbody class="ui-datatable-data ui-widget-content">
                <tr class="ui-widget-content" *ngFor="let item of subCategoriesList; index as indx">
                  <td>
                    <input [(ngModel)]="item.serial" disabled placeholder="code" type="text" class="form-control">
                  </td>
                  <td>
                    <input [(ngModel)]="item.descAr" [disabled]="item.dataStatus==0 || !item.dataStatus"
                      placeholder="Arabic Name" type="text" class="form-control">
                  </td>
                  <td>
                    <input [(ngModel)]="item.descEn" [disabled]="item.dataStatus==0 || !item.dataStatus "
                      placeholder="English Name" type="text" class="form-control">
                  </td>
                  <td>
                    <input [(ngModel)]="item.isActive" [disabled]="item.dataStatus==0 || !item.dataStatus"
                      placeholder="active" type="checkbox" class="form-control" (change)="isActiveChange($event,item)">
                  </td>

                  <td>
                    <icon-action (clicked)="onSubCategoryIconClicked($event , item)"
                      [appCodes]="[404,307,3]"></icon-action>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row" *ngIf="subCategoriesList.length>0">
            <div class="col">
              <btns-ctrl #btnCtrl1 [appCodes]="[1]" (clicked)="onSubCategorySaveClicked()"></btns-ctrl>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- invertions area -->
  <div class="col-4 card">
    <div class="title-tab-step text-center">
      {{ 'INTERVENTIONS' | translate }}
    </div>
    <div class="row">

      <div class="col-md-12">
        <div class="card-body">
          <div class=" col p-1 ui-datatable-tablewrapper">
            <table class="table table-bordered table-striped">
              <thead class="ui-datatable-thead">
                <tr>
                  <th style="width:20%;">{{ 'CODE' | translate }}</th>
                  <th style="width:20%;">{{ 'DESCNAMEAR' | translate }}</th>
                  <th style="width:20%;">{{ 'DESCNAMEEN' | translate }}</th>
                  <th style="width:20%;">{{ 'ACTIVE' | translate }}</th>


                  <th style="width:10%;" *ngIf="subCategoriesObj.serial>0">
                    <i (click)="addInterventionRow(1)" class="fa fa-plus fa-2x"></i>
                  </th>
                </tr>
              </thead>
              <tbody class="ui-datatable-data ui-widget-content">
                <tr class="ui-widget-content" *ngFor="let item of interventionList; index as indx">
                  <td>
                    <input [(ngModel)]="item.serial" disabled placeholder="code" type="text" class="form-control">
                  </td>
                  <td>
                    <input [(ngModel)]="item.descAr" [disabled]="item.dataStatus==0 || !item.dataStatus"
                      placeholder="Arabic Name" type="text" class="form-control">
                  </td>
                  <td>
                    <input [(ngModel)]="item.descEn" [disabled]="item.dataStatus==0 || !item.dataStatus "
                      placeholder="English Name" type="text" class="form-control">
                  </td>
                  <td>
                    <input [(ngModel)]="item.isActive" [disabled]="item.dataStatus==0 || !item.dataStatus"
                      placeholder="active" type="checkbox" class="form-control" (change)="isActiveChange($event,item)">
                  </td>

                  <td>
                    <icon-action (clicked)="onInterventionIconClicked($event , item)"
                      [appCodes]="[307,3]"></icon-action>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row" *ngIf="interventionList.length>0">
            <div class="col">
              <btns-ctrl #btnCtrl1 [appCodes]="[1]" (clicked)="onInterventionSaveClicked($event,1)"></btns-ctrl>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- 
<div class="container">
  <div *ngFor="let category of categories" class="category-section">
    <h3 style="color:blue">- {{category.name.ar}} -- {{category.name.en }}</h3>
    <div *ngFor="let subcategory of category.subcategories" class="subcategory-section">
      <h6 style="color:red">...
        {{subcategory.name.ar}} -- {{subcategory.name.en }}
      </h6>
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let intervention of subcategory.interventions">
          {{intervention.ar}} -- {{intervention.en }}
        </li>
      </ul>
    </div>
  </div>
</div> -->